import React, { lazy, Suspense, useEffect ,useState} from "react"
import ReactDom from "react-dom/client"
import "../App.css"
import Header from "./components/Header"
import Body from "./components/Body"
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom"
import About from "./components/About"
import ContactUs from "./components/ContactUs"
import Error from "./components/Error"

import RestaurantMenu from "./components/RestaurantMenu"
import Cart from "./components/Cart"
//import Grocery from "./components/Grocery";
import Home from "./components/Home"
import UserContext from "./components/UserContext"
import { Provider } from "react-redux"
import store from "./utils/store"
//RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/283329f9-5ad8-4c46-9177-6b23b6eb2966_17301.JPG
const Grocery = lazy(() => import("./components/Grocery"))



const AppLayout = () => {
  const [userName,setUserName]=useState("")

useEffect(()=>{
  fetchInfo()
},[])
const fetchInfo=async ()=>{
  const data=await fetch("https://github.com/Rahat463").catch((err)=>{
    console.log(err.message);
  })
  console.log(data);
  // const json=await data?.json()
  // console.log(json)
  setUserName(data?.type)
  console.log(data?.type)
  console.log("userName:",userName)
}
  return (
    <Provider store={store}>
    <UserContext.Provider value={{loggedInUser:userName,setUserName}} >
    <div className="app">
      <Header />
      <Outlet />
    </div>
    </UserContext.Provider>
    </Provider>
  )
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <ContactUs />,
      },
      {
        path: "/restaurants",
        element: <Body />,
      },
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/restaurants/:resId",
        element: <RestaurantMenu />,
      },
      {
        path: "/cart",
        element: <Cart />,
      },
      {
        path: "/grocery",
        element: (
          <Suspense fallback={<h1>Loading......</h1>}>
            <Grocery />
          </Suspense>
        ),
      },
    ],
    errorElement: <Error />,
  },
])

const root = ReactDom.createRoot(document.getElementById("root"))
//To ensure your code works correctly, always use the prop names as expected by the component.
// In this case, RouterProvider from react-router-dom expects a prop named router.
//wrong way: root.render(<RouterProvider route={router} />);
root.render(<RouterProvider router={router} />)
//ReactDom.render(<AppLayout/>,document.getElementById('root'));
